import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import { router } from "@/router";
import "@/styles/common.less";
import { Toast, Circle } from "vant";
import AppAvatar from "@/components/app-avatar.vue";
import AppTextOverflow from "@/components/app-text-overflow.vue";
import AppModal from "@/components/app-modal.vue";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueVirtualScroller from "vue-virtual-scroller";
import * as webtrackbrowser from "@/utils/web-track-browser";
import RiskUploader from "@/utils/sensor-risk";

var sensors = window["sensorsDataAnalytic201505"];
sensors.init({
  server_url: "https://sa.mszmapp.com/sa?project=xiya",
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: "beacon",
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: "default",
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: "not_collect",
    collect_tags: {
      div: true,
    },
  },
});
sensors.registerPage({
  current_url: location.href,
  referrer: document.referrer,
});
sensors.quick("autoTrack"); //用于采集 $pageview 事件。
window.sensors = sensors;

Vue.config.productionTip = false;
webtrackbrowser.init();
Vue.config.errorHandler = (err, vm, info) => {
  console.log("error1-------->", err, info);
  webtrackbrowser.sendInfo(err, info);
};

Vue.use(VueRouter);
Vue.use(Toast);
Vue.use(Circle);
Vue.use(VueVirtualScroller);
Vue.use(RiskUploader);
Vue.component("app-text-overflow", AppTextOverflow);
Vue.component("app-avatar", AppAvatar);
Vue.component("app-modal", AppModal);

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
